import { Margins, Content } from 'pdfmake/interfaces';
import pdfMake from 'pdfmake/build/pdfmake';
import { ConditionSeverityStatus } from '../types';
import { SeverityStatusColorMap } from '../helpers';

export type LegendsMap = { [key in ConditionSeverityStatus]: string };

pdfMake.tableLayouts = {
  TableLegendsLayout: {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingBottom: () => 0,
    paddingTop: () => 5,
    paddingLeft: () => 0,
    paddingRight: () => 5,
  },
};
export const buildLegends = (margin?: Margins): Content => {
  const statusNames = Object.keys(SeverityStatusColorMap) as ConditionSeverityStatus[];
  return {
    margin: margin ?? [0, 0],
    layout: 'TableLegendsLayout',

    table: {
      widths: [64, 64, 59, 62, 53, 53],
      body: [
        statusNames.map((item) => ({
          margin: [0, 0, 0, 0],
          widths: [5, '*'],

          alignment: 'right',

          columns: [
            {
              alignment: 'right',
              svg: `<svg width="8" height="8"><rect width="5" height="5" fill="${SeverityStatusColorMap[item]}" /></svg>`,
              margin: [0, 1, 0, 0],
            },
            {
              margin: [0, 0, 0, 0],
              text: item,
              width: 'auto',
              fontSize: 7,

              lineHeight: 0.8,
            },
          ],
        })),
      ],
    },
  };
};

export const legendAsString = JSON.stringify(buildLegends([150, 0, 0, 0]));
